import { getColorFromSlug } from "utility/colors";

export const cutStepDetails = [
    // {
    //     color: '#ff4a26',
    //     label: 'View',
    //     value: 'View',
    // },
    {
        color: '#ffdd03',
        label: 'Digout',
        value: 'Digout',
    },
    {
        color: '#FE9900',
        label: 'Base',
        value: 'Base',
    },
    {
        color: '#8200b5',
        label: 'Surface',
        value: 'Surface',
    },
    {
        color: `${getColorFromSlug('dark-red')}`,
        label: 'Concrete',
        value: 'Concrete',
    },
    {
        color: '#1d00d9',
        label: 'Crack Fill',
        value: 'Crack Fill',
    },
    // {
    //     name: "Complete",
    //     color: '#2da322',
    // }
];
